import { webcrypto as nodeWebcrypto, randomBytes } from 'crypto'

// 1M times in 550ms
export function fasterButCodeQLComplainsCheapUUID() {
  return `${Date.now()}.${Math.round(Math.random() * 100000)}`
}

// 1M times in 5135ms
export function cheapUUID() {
  const webCrypto = (globalThis as any).crypto?.getRandomValues
    ? (globalThis as any).crypto
    : nodeWebcrypto

  if (webCrypto?.getRandomValues) {
    const randomValue = webCrypto.getRandomValues(new Uint32Array(1))[0]
    return `${Date.now()}.${randomValue}`
  }

  const buffer = randomBytes(4)
  const randomValue = buffer.readUInt32LE(0)
  return `${Date.now()}.${randomValue}`
}
